import React, {useContext} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import {BoShowContext} from "../context/bo-show-context.jsx";
import {useLoaderData} from "react-router";

const BoShowPrintModal = ({open, setOpen, printRef}) => {
    const {printOptions, setPrintOptions} = useContext(BoShowContext);

    const loaderData = useLoaderData();

    const handleOption = (target) => {
        setPrintOptions(prev => ({...prev, [target]: !prev[target]}));
    }

    return (
        <Modal open={open} setOpen={setOpen} title={"Opções de impressão"} className={"w-4/12"} overflow={true}>
            <Modal.Body className={"space-y-4"}>
                <section className={"space-y-2"}>
                    <h4>Indivíduos</h4>

                    <InputCheckbox
                        id={"requester"}
                        label={"Exibir solicitantes na impressão"}
                        onChange={() => handleOption("requester")}
                        checked={printOptions.requester}
                    />
                    <InputCheckbox
                        id={"individual"}
                        label={"Ocultar dados pessoais de indivíduos"}
                        onChange={() => handleOption("individual")}
                        checked={printOptions.individual}
                    />
                </section>

                <section className={"space-y-2"}>
                    <h4>Responsável</h4>

                    <InputCheckbox
                        id={"approvalSignature"}
                        label={"Utilizar a assinatura do responsável pela aprovação"}
                        onChange={() => handleOption("approvalSignature")}
                        checked={printOptions.approvalSignature}
                    />
                    <InputCheckbox
                        id={"approvalName"}
                        label={"Exibir responsável pela aprovação do " + loaderData?.bo_name}
                        onChange={() => handleOption("approvalName")}
                        checked={printOptions.approvalName}
                    />
                </section>

                <section className={"space-y-2"}>
                    <h4>Anexos</h4>

                    <InputCheckbox
                        id={"image"}
                        label={"Exibir imagens na impressão"}
                        onChange={() => handleOption("image")}
                        checked={printOptions.image}
                    />
                    <InputCheckbox
                        id={"attachFullSize"}
                        label={"Imprimir um anexo por folha"}
                        onChange={() => handleOption("attachFullSize")}
                        checked={printOptions.attachFullSize}
                        disabled={!printOptions.image}
                    />
                </section>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => printRef.current?.print()}>
                    Imprimir
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BoShowPrintModal;